import UploaderController from "../uploader_controller";

export default class extends UploaderController {

  onSubmit() {
    // console.log('implementacao complexa de onSubmit')
  }

  onComplete(id, fileName, json)  {
    document.getElementById('file').innerHTML = json.html
    document.getElementById('botao_finalizar').innerHTML = json.html_botao
  }

}
